import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// items: [{ name, path }] — last item rendered as current (no link).
export default function Breadcrumbs({ items, dark }) {
  const tone = dark ? "text-white/70" : "text-slate-500";
  const current = dark ? "text-white font-medium" : "text-slate-700 font-medium";
  const linkCls = dark ? "hover:text-white hover:underline" : "hover:text-[#0B2A6B] hover:underline";
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`flex flex-wrap items-center gap-1 text-xs ${tone}`}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.path || it.name} className="inline-flex items-center gap-1">
            {last ? (
              <span className={current} aria-current="page">{it.name}</span>
            ) : (
              <Link to={it.path} className={linkCls}>{it.name}</Link>
            )}
            {!last && <ChevronRight className="h-3 w-3 opacity-60" />}
          </span>
        );
      })}
    </nav>
  );
}
